import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_EHRInstance } from './ModuleFE_EHRInstance.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const Props_DropDown = {
    module: ModuleFE_EHRInstance,
    modules: [ModuleFE_EHRInstance],
    mapper: item => [item.label],
    placeholder: 'Choose a EHRInstance',
    renderer: item => _jsxs("div", { className: "ll_h_c", children: [" ", item.label, " "] })
};
export const DropDown_EHRInstance = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_EHRInstance,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete, className: 'ts-icon__small' }), item.label] });
    },
    uiSelector: DropDown_EHRInstance.selectable,
});
export const MultiSelect_EHRInstance = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map